import { SortingState } from "@tanstack/react-table";
import { useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const useUrlParamsAndSorting = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get("page") || "1", 10);
  const pageSize = Number(searchParams.get("per_page") || "5");
  const sortBy = searchParams.get("sortBy");
  const sortOrder = searchParams.get("sortOrder");

  const sorting: SortingState = useMemo(
    () =>
      sortBy && sortOrder
        ? [{ id: sortBy, desc: sortOrder === "desc" }]
        : [{ id: "request_start_time", desc: true }],
    [sortBy, sortOrder],
  );

  const updateUrlParams = useCallback(
    (newPage = page, newPageSize = pageSize, newSorting = sorting) => {
      const params = new URLSearchParams(searchParams);
      params.set("page", newPage.toString());
      params.set("per_page", newPageSize.toString());

      if (newSorting.length > 0) {
        params.set("sortBy", newSorting[0].id);
        params.set("sortOrder", newSorting[0].desc ? "desc" : "asc");
      }

      setSearchParams(params, { replace: true });
    },
    [page, pageSize, searchParams, setSearchParams, sorting],
  );

  return {
    page,
    pageSize,
    sorting,
    updateUrlParams,
  };
};

export default useUrlParamsAndSorting;
